// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__Vde2C","modalTitle":"styles_modalTitle__qUAgz","modalDescription":"styles_modalDescription__THdXA","content":"styles_content__qCeIC"};